import type { FaireProductEntity } from "../../entity_types/product";

export const p_jevj6sycyt: FaireProductEntity = {
  token: "p_jevj6sycyt",
  type: "product",
  name: "Sea Salt Chocolate Bar 70% - 28g",
  brandName: "French Broad Chocolate",
  imageUrl:
    "https://cdn.faire.com/fastly/518b69ee68ecd0e28b036cf989c1b40d69ffe8eb1aa4908d3da485a650d2c92c.jpeg",
  priceDollars: 2.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/6fa6f99c7cf0ba8b081d4e556876d92b0a4ebe3d51c31a893083094fafa007c3.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
